<template>
  <div class='login'>
    <div class="logo">
      <img class="logo_img" src="/static/img/pc_logo.png"/>
      <p class="logo_text">微记清单</p>
    </div>
    <div class="content">
      <div class="text">
        <p class="main_text">微记清单</p>
        <p class="sub_text">记录你的生活</p>
      </div>
      <div class="login_form_div">
        <el-form ref="login_form" :rules="rules" class="login_form" :model="login_form">
          <div class="title">登录</div>
          <el-form-item class="phone" prop="telephone">
            <div class="label_icon"> <i class="icon iconfont icon-shouji"></i></div>
            <el-input
              class="phone_input"
              v-model="login_form.telephone"
              placeholder="手机号">
            </el-input>
          </el-form-item>
          <split></split>
          <el-form-item class="yzm" prop="yzm">
            <div class="label_icon"> <i class="icon iconfont icon-securityCode-b"></i></div>
            <el-input
              class="yzm_input"
              v-model="login_form.yzm"
              placeholder="验证码">
            </el-input>
            <div class="yzm_link"><span @click="send_yzm">获取验证码</span></div>
          </el-form-item>
          <split></split>
          <button class="login_btn" type="primary" @click.prevent="login_submit">登录</button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import headBar from './component/headBar.vue'
import mainBody from './component/mainBody.vue'
import split from '../others/split_line_1px.vue'
import axios from 'axios'
export default {
  name: 'mainPage',
  components: {
    headBar,
    mainBody,
    split
  },
  data: function () {
    return {
      login_form: {
        telephone: '',
        yzm: ''
      },
      rules: {
        telephone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        yzm: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    login_submit () {
      let _this = this
      this.$refs['login_form'].validate((valid) => {
        if (valid) {
          axios({
            method: 'get',
            url: _this.HOST + '/user/pcLogin',
            params: {
              telephone: _this.login_form.telephone,
              yzm: _this.login_form.yzm
            }
          }).then((res) => {
            let data = res.data
            console.log(data)
            if (data.statusCode === 200) {
              _this.$store.dispatch('setUserInfo', data.data)
              console.log('setUserInfo')
              _this.$router.push('/')
            } else {
              _this.$message({
                message: data.message,
                center: true,
                type: 'error'
              })
              console.log(data.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    send_yzm () {
      let telephone = this.login_form.telephone
      console.log(telephone)
      let _this = this
      if (telephone === '') {
        this.$message({
          message: '请输入手机号',
          center: true,
          type: 'warning'
        })
        return false
      } else {
        axios({
          method: 'get',
          url: _this.HOST + '/sms/loginOrRegister',
          params: {
            phone: telephone
          }
        }).then((res) => {
          let data = res.data
          console.log(data)
          if (data.statusCode === 200) {
            _this.$message({
              message: '验证码发送成功',
              center: true,
              type: 'success'
            })
          } else {
            _this.$message({
              message: data.message,
              center: true,
              type: 'error'
            })
            console.log(data.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="stylus">
.login
  position absolute
  top 0
  bottom 0
  left 0
  right 0
  background url("../../../static/img/pc_login_bg.png") no-repeat
  background-size cover
  .logo
    height 3.75rem
    background transparent
    width 10rem
    margin-left  2.5rem
    line-height 3.75rem
    font-size 0rem
    .logo_img
      width 2.25rem
      height 2.25rem
      display inline-block
      vertical-align middle
    .logo_text
      margin-left 1.5rem
      display inline-block
      vertical-align middle
      font-size 1.125rem
      font-weight 500
      color $white
  .content
    padding-top 8%
    height 30.5rem
    .text
      display inline-block
      vertical-align top
      width 40%
      padding-left 15%
      padding-top 5rem
      .main_text
        font-size 4.5rem
        color $white
        font-weight 500
      .sub_text
        margin-top 4rem
        font-size 3rem
        color $white
        letter-spacing 0.625rem
        font-weight 400
    .login_form_div
      display inline-block
      vertical-align top
      margin-left 8%
      .login_form
        width 21.625rem
        height 26.25rem
        padding 0 3.125rem
        border-top 0.375rem solid $elemBlue
        border-radius 0.25rem
        background $white
        .title
          text-align center
          padding 2.0625rem
          font-size 1.5rem
          font-weight 500
          color $elemBlue
        .login_btn
          width 100%
          height 2.8125rem
          outline none
          border none
          background $elemBlue
          color $white
          font-weight 500
          font-size 1.125rem
          border-radius 0.25rem
          margin-top 4rem
          cursor pointer
        .login_btn:hover
          background $dodger
        .phone
          margin 1.5rem 0 0 0
        .yzm
          margin 2rem 0 0 0
        .el-form-item
          .el-form-item__content
            height 3rem
            line-height 3rem
            display flex
            .label_icon
              flex 1
              font-size 1.5rem
              font-weight 900
              color $lightGrey
            .yzm_input
              flex 6
            .phone_input
              flex 11
            .yzm_link
              flex 5
              color $elemBlue
              text-align center
              font-size 1.125rem
              font-weight 400
              span
                padding-left 1rem
                border-left 0.0625rem solid $tinGrey
                cursor pointer
              span:hover
                color $grey
            .el-input
              input
                font-size 1.125rem
                height 3rem
                padding 0
                border none
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/login.vue